import React from 'react';
import QueryForm from './query-form/QueryForm';
import useBeaconFilters from './useBeaconFilters';
import { useRecoilState } from 'recoil';
import stateResultMode from '../../state/stateResultMode';
import ResultsViewSelector from './ResultViewSelector';
import ResultViewBiosamples from './ResultViewBiosamples';
import ResultViewVariants from './ResultViewVariants';
import { Box, Divider, Grid } from '@mui/material';


function SamplesBeacon() {
    const [resultMode, setResultMode] = useRecoilState(stateResultMode);
    useBeaconFilters();
    return (
        <Box padding={4}>
            <Box display="flex" flexDirection="row">
                <Box flexGrow={1} />
                <Box flexGrow={0} width="80em" textAlign="center">
                    <QueryForm />
                    <Box height="4em" />
                    <ResultsViewSelector />
                    <Divider />
                    <div>
                        {"biosamples" === resultMode && <ResultViewBiosamples />}
                        {"variants" === resultMode && <ResultViewVariants />}
                    </div>
                </Box>
                <Box flexGrow={1} />
            </Box>
        </Box>
    );
}


export default SamplesBeacon;
